import { render } from "./PDVEdit.vue?vue&type=template&id=a7866e36"
import script from "./PDVEdit.vue?vue&type=script&lang=js"
export * from "./PDVEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__